import config from '../config'

export const getPage = async (pageId, sectionId) => {
  // https://raw.githubusercontent.com/maanenh/sauerland/master/content/omgeving/oberhundem.md
  const response = await fetch(`${config.API_URL}${pageId}/${sectionId}.md`)
  return await response.text()
}
